import { render, staticRenderFns } from "./FormCISComplaint.vue?vue&type=template&id=18128c5d&scoped=true"
import script from "./FormCISComplaint.vue?vue&type=script&lang=js"
export * from "./FormCISComplaint.vue?vue&type=script&lang=js"
import style0 from "./FormCISComplaint.vue?vue&type=style&index=0&id=18128c5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18128c5d",
  null
  
)

export default component.exports